<template>
    <div class="container-login100" :class="{ 'login-desktop-bg' : !isTgMode }">
        <div class="wrap-login100">
            <form class="login100-form validate-form" ref="form">
                <!-- <span class="login100-form-logo">
                    <i class="zmdi zmdi-landscape"></i>
                </span> -->

                <span class="login100-form-title p-t-27">
                    Лабиринт
                </span>
              <span class="login100-form-subtitle p-b-34">авторизация через playlabirint.ru</span>

                <div class="wrap-input100 validate-input" data-validate="Необходимо заполнить">
                    <input v-model="username" class="input100" type="text" placeholder="Логин" required>
                    <span class="focus-input100" data-placeholder=""></span>
                </div>

                <div class="wrap-input100 validate-input" data-validate="Необходимо заполнить">
                    <input v-model="password" class="input100" type="password" placeholder="Пароль" required>
                    <span class="focus-input100" data-placeholder=""></span>
                </div>

                <p v-if="errorMessage" class="error-block">
                    {{ errorMessage }}
                </p>

                <div class="container-login100-form-btn">
                    <button
                        class="login100-form-btn"
                        @click="loginHandler"
                        :disabled="submitted"
                    >
                        Войти
                    </button>
                </div>

                <div class="text-center p-t-90">
                    <a class="txt1" href="https://playlabirint.ru/game/lost-password">
                        Забыли пароль?
                    </a>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { authService } from '../services/index.js'

export default {
  name: 'Login',

  data: () => ({
    username: '',
    password: '',
    submitted: false,
    errorMessage: null,
    isTgMode: false
  }),

  created () {
    const url = new URL(window.location.href)
    const param = url.searchParams.get('mode')

    if (param === 'tg') {
        this.isTgMode = true
    }
  },

  methods: {
      loginHandler (evt) {
          evt.preventDefault()
          this.submitted = true
          this.errorMessage = null

          authService.login({ username: this.username, password: this.password })
            .catch((response) => {
                this.errorMessage = response.data.message
                this.submitted = false
            })
      }
  }
}
</script>

<style scoped>
.login-desktop-bg {
    background-image: url('/images/main.jpg');
}

.login-desktop-bg::before {
    background-color: rgb(0 0 0 / 50%);
}

.wrap-login100 {
    background: -webkit-linear-gradient(top, #1eabbd, #0c0c0c);
}

.login100-form-btn {
    background: -webkit-linear-gradient(top,#1ea1b1, #1c7c88);
}

.error-block {
    margin-bottom: 30px;
    color: #f96565;
}
</style>
